import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaptionService } from '../../../../utils/shared-services/caption.service';
import { StoreSyncDetail, StoreSyncStatus } from "../../models/sync-status.model";
import { ConceptApiService } from "../../services/concept.resource";

interface Parameters {
    store: StoreSyncStatus;
    details: StoreSyncDetail[];
}

@Component({
    selector: "store-sync-details-dialog",
    templateUrl: "./src/app/features/concepts/templates/dialogs/store-sync-details-dialog.html",
    standalone: false
})
export class StoreSyncDetailsDialog {
    public captions: Record<string,string>;
    public details: StoreSyncDetail[] = [];

    private storeID: number;

    constructor(
        @Inject(CaptionService) private captionService: CaptionService,
        @Inject(ConceptApiService) private conceptApiService: ConceptApiService,
        @Inject(MAT_DIALOG_DATA) public data: Parameters,
    ) {
        this.captions = this.captionService.captions;
        this.storeID = data.store["StoreID"];
        this.details = data.details;
    }
}